import _ from 'lodash';
import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import responseKeyNormalizerMapping from './mapping';
import { MicroApp } from './micro';
import ClinicalResultFunctionBarService from './service/ClinicalResultFunctionBarService';
import ClinicalResultOperationService from './service/ClinicalResultOperationService';
export default class ClinicalResultDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
        this.silencedUpdateQueryKeys = ['page', 'sort'];
        this.microapp = new MicroApp(this.microAppId);
    }
    get enabled() {
        return localStorage.getItem('workspaceDetail:clinical_result') !== 'false';
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get ListOperationServiceClass() {
        return ClinicalResultOperationService;
    }
    get FunctionBarServiceClass() {
        return ClinicalResultFunctionBarService;
    }
    get isRefineEnabled() {
        return true;
    }
    get basicInfo() {
        return {
            key: this.name,
            index: 4,
            label: `dataType.${this.name}`,
            entryRoute: { name: 'detailClinicalResultRoot' },
        };
    }
    getReloadIdentifier(route) {
        const params = this._queryParamsNormalizer(route);
        return JSON.stringify(_.omit(params, this.silencedUpdateQueryKeys));
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(route) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(route),
            };
        }
        return {
            path: this.name,
            name: 'detailClinicalResultRoot',
            component: () => import('./ClinicalResultDetail.vue'),
            props: getDetailPageProps,
        };
    }
    _preload() {
        this.microapp.preload();
        return Promise.resolve();
    }
}
